import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectComponent } from './select/select.component';
import { CompleteComponent } from './complete/complete.component';
import { PickListModule } from 'primeng/picklist';
import { SafeHarborComponent } from './safeHarbor.component';
import { SafeHarborService } from './service/safeHarbor.service';
import { DatePickerModule } from 'primeng/datepicker';
import { SharedModule } from 'client/app/shared';

@NgModule({
  declarations: [SafeHarborComponent, SelectComponent, CompleteComponent],
  providers: [
    SafeHarborService
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    PickListModule,
    SharedModule,
    DatePickerModule
  ],
})
export class SafeHarborModule { }